import React from 'react'
import { useMediaQuery } from 'react-responsive'

const smallQuoteSvg = (
    <svg width="93" height="127" viewBox="0 0 93 127" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M42.4936 0H92.698L52.2998 53.342H78.4497V126.687H0V53.342L42.4936 0Z" fill="#F3F7FA" />
    </svg>
)

const bigQuoteSvg = (
    <svg width="155" height="213" viewBox="0 0 155 213" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M70.9794 0.457031H154.839L87.3593 89.5572H131.039V212.07H0V89.5572L70.9794 0.457031Z" fill="#F3F7FA" />
    </svg>
)

const Testimonial = ({ activeType, currentImages, t }) => {
    const isMobile = useMediaQuery({ query: '(max-width: 991px)' })
    const quoteSvg = isMobile ? smallQuoteSvg : bigQuoteSvg
    return (
        <div className="mfb-testimonial">
            <div className="mfb-testimonial__quote">
                {quoteSvg}
                {quoteSvg}
            </div>
            <div className="mfb-testimonial__title">{t(activeType.texts.testimonial.title)}</div>
            <div className="mfb-testimonial__text">{t(activeType.texts.testimonial.text)}</div>
            <div className="mfb-testimonial__author">
                <img src={currentImages.testimonial} alt="" />
                <span>{t(activeType.texts.testimonial.author)}</span>
            </div>
            <div className="mfb-testimonial__quote">
                {quoteSvg}
                {quoteSvg}
            </div>
        </div>
    )
}

export default Testimonial
